import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Box from '@mui/material/Box';
import React, { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { AssetGroupContext } from '../../../AssetGroup/assetGroupContextWrapper';
import { CONSTANTS } from '../../../../constants/constants';
import WithPermissions from '../../../Permissions/WithPermissions';
import { ACR_RESOURCE_TYPE } from '../../../../pages/NRSettings/NRUsersAndAccess/rbac.constants';

const LinkFormatter = ({ row }) => {
  const { selectedGroups, setSelectedGroups, disableEdit } = useContext(AssetGroupContext);

  const handleRemoveGroup = () => {
    setSelectedGroups(selectedGroups.filter(e => e.id !== row.id));
  };

  return (
    <WithPermissions permission={CONSTANTS.PERMISSIONS.WRITE_GROUPS} resourceType={ACR_RESOURCE_TYPE.ASSET_GROUP} resourceId={row?.id}>
      {!disableEdit && (
        <Box key={row?.id}>
          <IconButton aria-label="Close" onClick={handleRemoveGroup} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </WithPermissions>
  );
};
export const NRAssetGroupDeleteProvider = props => <DataTypeProvider formatterComponent={LinkFormatter} {...props} />;
